<template>
  <div>
    <hero-bar>
      <div slot="title">Listado de Caballos</div>
      <div slot="sub-title">Caballos pertenecientes a la escuela</div>
      <div slot="right">
        <div class="columns">
          <div class="column"></div>
          <div class="column is-narrow">
            <b-button type="is-primary" icon-left="plus" @click="isComponentModalActive = true">Añadir Caballo</b-button>
          </div>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <horses-table @edit="editHorse" :reload.sync="reloadTable"/>
    </section>
    <horse-form :active.sync="isComponentModalActive" :horse-id.sync="horseIdSelected" @saved="reloadTable = true"/>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import HorsesTable from './components/HorsesTable'
import HorseForm from './components/HorseForm'

export default {
  components: {
    HorsesTable,
    HeroBar,
    HorseForm
  },
  data () {
    return {
      isComponentModalActive: false,
      horseIdSelected: null,
      reloadTable: false
    }
  },
  methods: {
    editHorse (data) {
      if (data) {
        this.horseIdSelected = data
        this.isComponentModalActive = true
      }
    }
  }
}
</script>
